(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider', '$urlRouterProvider'];

    function stateConfig($stateProvider, $stickyStateProvider, $urlRouterProvider ) {
        $stateProvider
        .state('keyword', {
            // parent: 'entity',
            parent: 'app',
            url: '/keyword?page&sort&search',
            sticky: true,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI'],
                pageTitle: 'ccsTrApp.keyword.home.title',
                title: 'Keywords'
            },
            views: {
                // 'content@': {
                'keyword@': {
                    templateUrl: 'app/entities/keyword/keywords.html',
                    controller: 'KeywordController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('keyword');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('keyword-detail', {
            // parent: 'entity',
            parent: 'app',
            url: '/keyword/{id}',
            sticky: true,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI'],
                pageTitle: 'ccsTrApp.keyword.detail.title',
                title: 'Detail'
            },
            views: {
                // 'content@': {
                'keyword-detail@': {
                    templateUrl: 'app/entities/keyword/keyword-detail.html',
                    controller: 'KeywordDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('keyword');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Keyword', function($stateParams, Keyword) {
                    return Keyword.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'keyword',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('keyword-detail.edit', {
            // parent: 'keyword-detail',
            parent: 'app',
            // url: '/detail/edit',
            url: '/keyword/detail/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/keyword/keyword-dialog.html',
                    controller: 'KeywordDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Keyword', function(Keyword) {
                            return Keyword.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('keyword.new', {
            // parent: 'keyword',
            parent: 'app',
            // url: '/new',
            url: '/keyword/new',
            sticky: false,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/keyword/keyword-dialog.html',
                    controller: 'KeywordDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createdOn: null,
                                createdBy: null,
                                modifiedOn: null,
                                modifiedBy: null,
                                type: null,
                                value: null,
                                desc: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('keyword', null, { reload: true });
                }, function() {
                    $state.go('keyword');
                });
            }]
        })
        .state('keyword.edit', {
            // parent: 'keyword',
            parent: 'app',
            // url: '/{id}/edit',
            url: '/keyword/{id}/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/keyword/keyword-dialog.html',
                    controller: 'KeywordDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Keyword', function(Keyword) {
                            return Keyword.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('keyword', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('keyword.delete', {
            // parent: 'keyword',
            parent: 'app',
            // url: '/{id}/delete',
            url: '/keyword/{id}/delete',
            sticky: false,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/keyword/keyword-delete-dialog.html',
                    controller: 'KeywordDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Keyword', function(Keyword) {
                            return Keyword.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('keyword', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });

        $stickyStateProvider.enableDebug( true );

    }

})();
